import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import SelectedToggle from './SelectedToggle';

interface WDProps {
  weekDays: string;
  hasEditPermission?: boolean;
  handleFormat(
    event: React.MouseEvent<HTMLElement>,
    newFormats: string[],
  ): void;
}

const useStyles = makeStyles(() => ({
  weekdayButton: {
    padding: '7px 6px',
    maxWidth: 35,
    '&.MuiToggleButton-root.Mui-selected': {
      background: 'lightgray',
    },
  },
}));

const weekdaysArr = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export default function WeekDays({
  weekDays,
  hasEditPermission = true,
  handleFormat,
}: WDProps) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <ToggleButtonGroup
        value={weekDays}
        onChange={handleFormat}
        aria-label="weekdays selection"
        size="small"
        style={{ marginBottom: 15, backgroundColor: 'white', margin: 'auto' }}
      >
        {weekdaysArr.map((weekday, i) => {
          const index = i === 6 ? 1 : i + 2;
          const weekdayStr = `${index} - ${weekday}`;
          const lowercaseWeekday = weekday.toLowerCase();
          return (
            <ToggleButton
              key={weekdayStr}
              value={weekdayStr}
              aria-label={lowercaseWeekday}
              className={classes.weekdayButton}
              disabled={!hasEditPermission}
            >
              {weekDays.includes(weekdayStr) ? (
                <SelectedToggle
                  text={t(
                    `app.common.calendar.${lowercaseWeekday}_short`,
                    `${lowercaseWeekday}`,
                  )}
                />
              ) : (
                <Typography style={{ marginLeft: 3, marginRight: 3 }}>
                  {t(
                    `operationHours.weekday.${lowercaseWeekday}_short`,
                    `${lowercaseWeekday}`,
                  )}
                </Typography>
              )}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </>
  );
}
